import React from "react";
import { type FreefieldInputProps } from "../models";
import moment from "moment";
import { OptionalDatePicker } from "components/DatePicker/OptionalDatePicker";

const isValidDate = (date: string) => {
  if (date == null || date === "" || date === "0") return false;
  return true;
};

const FreefieldDate = (props: FreefieldInputProps) => {
  const [date, setDate] = React.useState(isValidDate(props.initialValue) ? moment.utc(props.initialValue) : undefined);

  const onDateChange = (date: moment.Moment) => {
    setDate(date);
    props.onChange(date ? date.toISOString() : undefined);
  };

  return <OptionalDatePicker
    validatorKey={`freefieldDate${props.reference}`}
    minDate={moment(serverReference.constants.appointment.minDate)}
    maxDate={moment(serverReference.constants.appointment.maxDate)}
    value={date}
    onChange={onDateChange}
  />;
};

export default FreefieldDate;